import * as React from 'react';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';
import { useAccountIbansTRelFinNumFin } from '../../hooks';

export const AccountIbanTRelFinNumFin = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountIbansTRelFinNumFin();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
